import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import './Teaser.scss';
const TeaserTitle = ({ children }) => (_jsx("h3", { className: "title", children: children }));
const TeaserText = ({ children }) => (_jsx("p", { className: "text", children: children }));
export const Teaser = ({ children, imageSrc, imageAlt }) => (_jsxs("article", { className: "teaser", children: [imageSrc && _jsx("figure", { children: _jsx("img", { src: imageSrc, alt: imageAlt !== null && imageAlt !== void 0 ? imageAlt : '' }) }), children] }));
Teaser.Title = TeaserTitle;
Teaser.Text = TeaserText;
